import { render, staticRenderFns } from "./casemanage.vue?vue&type=template&id=020f274b&scoped=true&"
import script from "./casemanage.vue?vue&type=script&lang=js&"
export * from "./casemanage.vue?vue&type=script&lang=js&"
import style0 from "./casemanage.vue?vue&type=style&index=0&id=020f274b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020f274b",
  null
  
)

export default component.exports